export enum CreditRequestStatusEnum {
  NEEDS_ESTIMATION = 'NEEDS_ESTIMATION',
  WAITING_CUSTOMER_ACCEPTANCE = 'WAITING_CUSTOMER_ACCEPTANCE',
  ESTIMATE_REJECTED = 'ESTIMATE_REJECTED',
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  PAUSED = 'PAUSED',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED'
}
